import { TextField, AreaField, Card } from "../Field";
import { DateField } from "../DateField";

export default function OsnovniTab({ record, update, settings }) {
  const o = record.osnovni;
  const set = (k) => (v) => update({ osnovni: { ...o, [k]: v } });
  const nastavni = record.tip === "nastavni";

  return (
    <div className="grid gap-5">
      <Card title="Osnovni podaci" subtitle={nastavni ? "Podaci o dežurstvu za nastavni dan" : "Podaci o dežurstvu za nenastavni dan"}>
        <div className="grid gap-4 sm:grid-cols-2">
          <DateField label="Datum" value={record.datum} onChange={(v) => update({ datum: v })} testId="form-datum-input" />
          {settings.opcije.smjene && (
            <div className="space-y-1.5">
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Smjena</label>
              <select
                data-testid="form-smjena-select"
                value={o.smjena}
                onChange={(e) => set("smjena")(e.target.value)}
                className="w-full rounded-xl border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 outline-none focus:border-sky-500 focus:ring-2 focus:ring-sky-100"
              >
                <option value="">Odaberite smjenu</option>
                <option value="Jutarnja smjena">Jutarnja smjena</option>
                <option value="Popodnevna smjena">Popodnevna smjena</option>
                <option value="Cjelodnevna nastava">Cjelodnevna nastava</option>
              </select>
            </div>
          )}
          {settings.opcije.podrucneSkole && (
            <TextField label="Lokacija / područna škola" value={o.podrucnaSkola} onChange={set("podrucnaSkola")} testId="form-podrucna-input" placeholder="npr. Matična škola ili PŠ Ivanovac" />
          )}
        </div>
        {!nastavni && (
          <TextField label="Razlog nenastavnog dana" value={o.razlogNenastavnog} onChange={set("razlogNenastavnog")} testId="form-razlog-input" placeholder="npr. državni praznik, stručno usavršavanje, zimski odmor" />
        )}
        <AreaField label="Dežurno osoblje" value={o.dezurnoOsoblje} onChange={set("dezurnoOsoblje")} testId="form-dezurno-osoblje-input" placeholder="Upišite imena dežurnog osoblja, svaki red novi unos" />
        <TextField
          label={nastavni ? "Glavni dežurni učitelj" : "Glavni dežurni djelatnik"}
          value={o.glavniDezurni}
          onChange={set("glavniDezurni")}
          testId="form-glavni-dezurni-input"
          placeholder="Ime i prezime"
        />
      </Card>

      {nastavni && (
        <Card title="Raspored dežurnih učitelja" subtitle="Po lokacijama u školi">
          <AreaField label="Dežurni učitelji u prizemlju" value={o.dezurniPrizemlje} onChange={set("dezurniPrizemlje")} testId="form-prizemlje-input" rows={2} />
          <AreaField label="Dežurni učitelji na katu" value={o.dezurniKat} onChange={set("dezurniKat")} testId="form-kat-input" rows={2} />
          <AreaField label="Dežurni učitelji u međusmjeni" value={o.dezurniMedjusmjena} onChange={set("dezurniMedjusmjena")} testId="form-medjusmjena-input" rows={2} />
          {settings.opcije.dezurniUcenici && (
            <AreaField label="Dežurni učenici" value={o.dezurniUcenici} onChange={set("dezurniUcenici")} testId="form-dezurni-ucenici-input" rows={2} placeholder="Imena dežurnih učenika" />
          )}
        </Card>
      )}

      <Card title="Napomena" subtitle="Dodatne informacije uz osnovne podatke">
        <AreaField label="Napomena" value={o.napomena} onChange={set("napomena")} testId="form-napomena-osnovno-input" rows={2} />
      </Card>
    </div>
  );
}
